import { useContext, useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ServiceContext } from "providers/ServiceProvider";

const useHistoryWithContext = () => {
  const [activeService] = useContext(ServiceContext);
  const history = useHistory();
  const [HistoryWithContext, setHistoryWithContext] = useState(history);

  const getContextUrl = useCallback(url => {
    if (activeService == null) return "/";
    return `/${activeService.route}${url}`;
  }, [activeService]);

  const push = useCallback((url, state) => {
    history.push(getContextUrl(url), state);
  }, [getContextUrl, history]);

  useEffect(() => {
    setHistoryWithContext(prevState => ({ ...prevState, push, getContextUrl }));
  }, [getContextUrl, push]);

  return HistoryWithContext;
};

export default useHistoryWithContext;
